/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const wearables_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M9.25 18.5a.75.75 0 0 0-1.5 0h1.5Zm7 0a.75.75 0 0 0-1.5 0h1.5ZM15.09 1.43l-.543.517.543-.517Zm-.34 4.07a.75.75 0 0 0 1.5 0h-1.5Zm-7 0a.75.75 0 0 0 1.5 0h-1.5Zm1.16-4.07.543.517-.543-.517Zm5.19 20.82H9.9v1.5h4.2v-1.5Zm-4.2 0a.619.619 0 0 1-.447-.197l-1.085 1.035c.4.42.95.662 1.532.662v-1.5Zm-.447-.197a.753.753 0 0 1-.203-.52h-1.5c0 .577.218 1.137.618 1.555l1.085-1.035Zm-.203-.52V18.5h-1.5v3.033h1.5Zm5.5-3.033v3.033h1.5V18.5h-1.5Zm0 3.033a.753.753 0 0 1-.203.52l1.085 1.035c.4-.418.618-.978.618-1.555h-1.5Zm-.203.52a.619.619 0 0 1-.447.197v1.5c.582 0 1.132-.242 1.532-.662l-1.085-1.035ZM9.9 1.75h4.2V.25H9.9v1.5Zm4.2 0c.16 0 .322.067.447.197L15.632.912c-.4-.42-.95-.662-1.532-.662v1.5Zm.447.197a.753.753 0 0 1 .203.52h1.5c0-.577-.218-1.137-.618-1.555l-1.085 1.035Zm.203.52V5.5h1.5V2.467h-1.5ZM9.25 5.5V2.467h-1.5V5.5h1.5Zm0-3.033c0-.201.077-.388.203-.52L8.368.912c-.4.418-.618.978-.618 1.555h1.5Zm.203-.52A.619.619 0 0 1 9.9 1.75V.25c-.582 0-1.132.242-1.532.662l1.085 1.035ZM18.25 12A6.25 6.25 0 0 1 12 18.25v1.5A7.75 7.75 0 0 0 19.75 12h-1.5ZM12 18.25A6.25 6.25 0 0 1 5.75 12h-1.5A7.75 7.75 0 0 0 12 19.75v-1.5ZM5.75 12A6.25 6.25 0 0 1 12 5.75v-1.5A7.75 7.75 0 0 0 4.25 12h1.5ZM12 5.75A6.25 6.25 0 0 1 18.25 12h1.5A7.75 7.75 0 0 0 12 4.25v1.5Z"
    />
  </svg>
)
export default wearables_medium
